import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=67da40b8"
import script from "./paymentInfo.vue?vue&type=script&lang=js"
export * from "./paymentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports